'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.825.117c.649 0 1.175.443 1.175.99 0 .547-.526.99-1.175.99H5.047c-.649 0-1.175-.443-1.175-.99 0-.547.526-.99 1.175-.99h11.778Zm0 4.951c.649 0 1.175.443 1.175.99 0 .547-.526.99-1.175.99H5.047c-.649 0-1.175-.443-1.175-.99 0-.547.526-.99 1.175-.99h11.778Zm0 4.951c.649 0 1.175.444 1.175.99 0 .548-.526.991-1.175.991H5.047c-.649 0-1.175-.443-1.175-.99 0-.547.526-.99 1.175-.99h11.778ZM1 11.903a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM1 6.95a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM1 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var UnorderedList = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.UnorderedList = UnorderedList;